import clsx from 'clsx';
import { useCallback } from 'react';

import { Filter } from '~modules/media-library/model/Filter';
import { isCheckFilter } from '~modules/media-library/model/FilterValidator';

type TabFilterBarProps = {
  tabFilter: Filter;
  selectedTabFilterId: Filter['id'];
  onSetSelectedTabFilterId: (filterId: Filter['id']) => void;
};

export function TabFilterBar({ tabFilter, onSetSelectedTabFilterId, selectedTabFilterId }: TabFilterBarProps) {
  const handleOnItemClick = useCallback(
    (filterId: Filter['id']) => () => {
      onSetSelectedTabFilterId(filterId);
    },
    [onSetSelectedTabFilterId],
  );
  if (isCheckFilter(tabFilter)) {
    return (
      <div
        role="tablist"
        className="border-t-0 border-l-0 mb-3 border-r-0 border-b border-solid border-darkgray flex gap-6"
      >
        {tabFilter.options.map(filter => {
          return (
            <button
              role="tab"
              key={filter.id}
              onClick={handleOnItemClick(filter.id)}
              className={clsx(
                'appearance-none border-t-0 border-l-0 border-r-0 border-b-2',
                'border-solid outline-none font-sans text-sm text-black bg-transparent m-0 px-0 pb-1 cursor-pointer',
                selectedTabFilterId === filter.id ? 'border-black font-semibold' : 'border-transparent',
              )}
            >
              {filter.label}
            </button>
          );
        })}
      </div>
    );
  }
  return null;
}
